import {AdvertDTO} from "./advertDTO.interface";

export interface SphAllDTO {
  advert: AdvertDTO;
}
